import styled from "styled-components";
import { statusData } from "../data";

const StatBoxWrapper = styled.div`
  margin: 40px auto 16px auto;
  width: 1520px;
  max-width: 99vw;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 16px;
`;

const StatButton = styled.div`
  background-color: ${(props) => props.bgColor + "80"}; // 투명도 50%
  display: flex;
  justify-content: space-between;
  padding: 8px 32px;
  border-radius: 40px;
  font-weight: bold;
  &:hover {
    cursor: default;
  }
`;

const StatBox = ({ allQsStatData, isMyQs, myQsStatData }) => {
  return (
    <StatBoxWrapper>
      {(isMyQs ? myQsStatData : allQsStatData).map((el, idx) => {
        const data = statusData.find((el) => el.value === String(idx));
        return (
          <StatButton key={idx} bgColor={data?.hex || "#BEBEBE"}>
            <span>{data?.text || "전체"}</span>
            <span>{el}건</span>
          </StatButton>
        );
      })}
    </StatBoxWrapper>
  );
};

export default StatBox;
